import * as React from 'react';
import { Component } from 'react';
import * as filesize  from 'filesize';
import moment from 'moment-es6';

class FileComponent extends Component {

    constructor(props) {
        super(props);
        this.onClearButtonClicked = this.onClearButtonClicked.bind(this);
    }

    onClearButtonClicked() {
       this.props.onFileClosed();
    }

    render() {

        const { file } = this.props;

        return (
            <div className="attachment">

                <div className="attachment__icon">
                    <i className="fa fa-2x fa-file-excel-o opacity--75" />
                </div>

                <div className="attachment__body">

                    <div className="attachment__name">
                        <span className="">{file.name}</span>
                    </div>

                    <div className="attachment__meta text--smallest display--flex display--flex--align-center">
                        <span className="opacity--50 push-quarter--right">Size: {filesize.default(file.size)}</span>
                        &middot;
                        <span className="opacity--50 push-quarter--sides">{moment().fromNow()}</span>
                    </div>

                </div>

                <button className="attachment__action btn btn--transparent" onClick={this.onClearButtonClicked}>
                    <i className="alert__close__icon icon-cme-close-thin icon--small" aria-hidden="true" />
                </button>

            </div>
        );
    }
}

export default FileComponent;



// WEBPACK FOOTER //
// ./styleguide/components/sections/FileComponent.js